import { CLEAR_DIRTY_FORM, SET_DIRTY_FORM } from '../actions/dirty-forms.actions';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_DIRTY_FORM:
      return { ...initialState };
    case SET_DIRTY_FORM: {
      return { ...state, [action.payload.form]: action.payload.value };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/reducers/dirty-forms.reducer.js